import React from 'react'

const AbsolutePosition = ({
    children,
    top,
    right,
    zIndex = 100,
}) => {
    return (
        <div
            style={{
                position: 'absolute',
                top,
                right,
                zIndex
            }}
        >
            {children}
        </div>
    )
}

export default AbsolutePosition